import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import {
  Button, FormGroup,
  InputGroup, FormControl,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import styles from './styles.css';
import ConfirmButton from '../confirm-button';

let holder = null;

class ValueItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
      editingMode: false,
      saving: false,
      label: props.value ? props.value.label : null,
    };
    this.deleteValue = this.deleteValue.bind(this);
    this.saveLabel = this.saveLabel.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.cancelEditing = this.cancelEditing.bind(this);
    this.toggleDefault = this.toggleDefault.bind(this);
    if (typeof window !== 'undefined') {
      const table = document.createElement('table');
      table.classList.add(styles.tablePortal);
      table.classList.add('table');
      table.classList.add('table-condensed');
      const tbody = document.createElement('tbody');
      table.appendChild(tbody);
      document.body.appendChild(table);
      holder = tbody;
    }
  }


  saveLabel() {
    const { value } = this.props;
    const { label, saving } = this.state;
    if (!saving) {
      this.setState({ saving: true });
      this.props.requestUpdateValue({ ...value, label })
        .then(
          () => {
            this.setState({ saving: false, editingMode: false });
          },
          () => {
            this.setState({ saving: false });
          },
        );
    }
  }

  toggleDefault() {
    const { value, disabled } = this.props;
    const { saving } = this.state;
    if (!saving && !disabled) {
      const id = value._id;
      this.setState({ saving: true });
      this.props.requestUpdateDefault(id, value.default === false)
        .then(
          () => {
            this.setState({ saving: false });
          },
          () => {
            this.setState({ saving: false });
          },
        );
    }
  }

  handleValueChange(e) {
    this.setState({ label: e.target.value });
  }

  cancelEditing() {
    this.setState({ label: null, editingMode: false });
  }

  deleteValue(value) {
    const { deleting } = this.state;
    if (!deleting) {
      this.setState({ deleting: true });
      this.props.requestRemoveValue(value)
        .then(
          () => {
            // this.setState({ deleting: false });
          },
          () => {
            this.setState({ deleting: false });
          },
        );
    }
  }

  renderEditor() {
    const {
      deleting, label, saving,
    } = this.state;
    const { showCancelButton, disabled } = this.props;
    const blocked = deleting || saving || disabled;
    return (
      <FormGroup style={{ margin: 0 }}>
        <InputGroup bsSize="sm">
          <FormControl
            type="text"
            value={label || ''}
            disabled={blocked}
            placeholder="enter value label"
            autoFocus
            onChange={this.handleValueChange}
          />
          <InputGroup.Addon>
            <Button
              bsSize="sm"
              disabled={blocked || !label || label.length === 0}
              onClick={this.saveLabel}
            >
              Save
            </Button>
            {showCancelButton &&
              <Button
                bsSize="sm"
                bsStyle="link"
                disabled={blocked}
                onClick={this.cancelEditing}
              >
                Cancel
              </Button>
            }
          </InputGroup.Addon>
        </InputGroup>
      </FormGroup>
    );
  }

  renderLabel() {
    const { editingMode } = this.state;
    const { value } = this.props;
    const hasValue = value && value.label && value.label.length > 0;
    const display = hasValue ? value.label : 'click to edit label';
    if (editingMode || !hasValue) {
      return this.renderEditor();
    }
    return (
      <a
        href=""
        onClick={(e) => {
          e.preventDefault();
          if (!this.props.disabled) {
            this.setState({ editingMode: true, label: value.label });
          }
        }}
      >
        {display}
      </a>
    );
  }

  renderDefaultCheckbox() {
    const { deleting, saving } = this.state;
    const { value, isMultiple, disabled } = this.props;
    const isChecked = value.default === true;
    const blocked = deleting || saving || disabled;
    let faName = 'circle-o';
    if (isMultiple) {
      if (isChecked) {
        faName = 'check-square-o';
      } else {
        faName = 'square-o';
      }
    } else if (isChecked) {
      faName = 'check-circle-o';
    } else {
      faName = 'circle-o';
    }
    return (
      <div
        style={{ fontSize: '1.3em', cursor: blocked ? 'not-allowed' : 'pointer' }}
        onClick={this.toggleDefault}
        role="button"
        tabIndex="-1"
      >
        <Fa name={faName} className={isChecked ? 'text-success' : 'text-muted'} />
      </div>
    );
  }

  render() {
    const { deleting, editingMode } = this.state;
    const {
      value, disabled,
      innerRef, draggableProps,
      isDragging, dragHandleProps,
      updatingDragging,
    } = this.props;
    const blocked = deleting || editingMode || disabled;
    const blinking = false;
    let faName = 'arrows';
    if (updatingDragging) {
      faName = 'spinner';
    }
    const child = (
      <tr
        ref={innerRef}
        {...draggableProps}
        className={`${isDragging ? styles.dragging : ''} ${blinking ? 'animated flash' : ''}`}
        style={draggableProps.style}
      >
        <td
          width="30"
          className="text-center"
          {...dragHandleProps}
        >
          <Fa name={faName} spin={updatingDragging} />
        </td>
        <td>
          {this.renderLabel()}
        </td>
        <td className="text-center">
          {this.renderDefaultCheckbox()}
        </td>
        <td>
          <ConfirmButton
            size="sm"
            disabled={blocked}
            confirmMessage="?"
            confirmStyle="link"
            onConfirm={() => { this.deleteValue(value); }}
          >
            {deleting && <Fa name="spinner" spin className="text-muted" />}
            {!deleting && <Fa name="trash" />}
          </ConfirmButton>
        </td>
      </tr>
    );

    if (!isDragging || !holder) {
      return child;
    }
    return ReactDOM.createPortal(child, holder);
  }
}

ValueItem.propTypes = {
  isMultiple: PropTypes.bool,
  value: PropTypes.shape({
    _id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  requestRemoveValue: PropTypes.func,
  requestUpdateValue: PropTypes.func,
  requestUpdateDefault: PropTypes.func,
  showCancelButton: PropTypes.bool,
  disabled: PropTypes.bool,
  dragHandleProps: PropTypes.shape({}).isRequired,
  draggableProps: PropTypes.shape({}).isRequired,
  innerRef: PropTypes.func.isRequired,
  isDragging: PropTypes.bool,
  updatingDragging: PropTypes.bool,
};
ValueItem.defaultProps = {
  isMultiple: false,
  showCancelButton: false,
  requestRemoveValue: () => Promise.reject(new Error('need handler')),
  requestUpdateValue: () => Promise.reject(new Error('need handler')),
  requestUpdateDefault: () => Promise.reject(new Error('need handler')),
  disabled: false,
  isDragging: false,
  updatingDragging: false,
};

export default ValueItem;
